module.exports = __webpack_public_path__ + "static/media/company_logo.4a46be22.png";